const text = "_35std2xpgi";

export { text };
import "./tile.text.style.linaria.module.css";
//# sourceMappingURL=tile.text.style.js.map
